export const values = [
    {
        title: "Integrity",
        description: "We uphold transparency, confidentiality, and ethical standards in all our services.",
        icon: "shield-check"
    },
    {
        title: "Innovation",
        description: "We embrace forward-thinking tools and techniques to deliver effective HR solutions.",
        icon: "lightbulb"
    },
    {
        title: "Empowerment",
        description: "We believe in equipping clients with the tools and knowledge to become self-sustaining.",
        icon: "trending-up"
    },
    {
        title: "Excellence",
        description: "We are committed to high-quality service delivery, backed by decades of global experience.",
        icon: "award"
    },
    {
        title: "Collaboration",
        description: "We work closely with our clients, building lasting partnerships for mutual growth.",
        icon: "users"
    }
];







export const icons = {
    "shield-check": (
        <svg width="36" height="36" fill="none" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="#2340CE" d="M12 2l7 4v5c0 5.25-3.5 10-7 11-3.5-1-7-5.75-7-11V6l7-4z" opacity="0.15" />
            <path stroke="#2340CE" strokeWidth="1.5" d="M12 2l7 4v5c0 5.25-3.5 10-7 11-3.5-1-7-5.75-7-11V6l7-4z" />
            <path stroke="#2340CE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4" />
        </svg>
    ),
    "lightbulb": (
        <svg width="36" height="36" fill="none" viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="10" r="6" fill="#2340CE" opacity="0.15" />
            <circle cx="12" cy="10" r="6" stroke="#2340CE" strokeWidth="1.5" />
            <path stroke="#2340CE" strokeWidth="1.5" strokeLinecap="round" d="M9 17h6M10 20h4" />
        </svg>
    ),
    "trending-up": (
        <svg width="36" height="36" fill="none" viewBox="0 0 24 24" aria-hidden="true">
            <polyline points="3 17 9 11 13 15 21 7" stroke="#2340CE" strokeWidth="1.5" fill="none" />
            <polyline points="14 7 21 7 21 14" stroke="#2340CE" strokeWidth="1.5" fill="none" />
        </svg>
    ),
    "award": (
        <svg width="36" height="36" fill="none" viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="8" r="6" fill="#2340CE" opacity="0.15" />
            <circle cx="12" cy="8" r="6" stroke="#2340CE" strokeWidth="1.5" />
            <path stroke="#2340CE" strokeWidth="1.5" d="M8 15l-2 6 6-3 6 3-2-6" />
        </svg>
    ),
    "users": (
        <svg width="36" height="36" fill="none" viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="9" cy="7" r="4" fill="#2340CE" opacity="0.15" />
            <circle cx="9" cy="7" r="4" stroke="#2340CE" strokeWidth="1.5" />
            <circle cx="17" cy="11" r="3" stroke="#2340CE" strokeWidth="1.5" />
            <path stroke="#2340CE" strokeWidth="1.5" d="M2 21v-1a5 5 0 015-5h4a5 5 0 015 5v1" />
            <path stroke="#2340CE" strokeWidth="1.5" d="M14 21v-1a3 3 0 013-3h1" />
        </svg>
    )
};